import React from 'react'
import "./power.scss";
import { motion } from "framer-motion";
import Navbar from '../landing/header/Navbar';
import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import Workflows from '../landing/workflows/Workflows';
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Industries from '../landing/Industries/Industries';
import Headernew from '../landing/headernew/Headernew';
import ScheduleButton from '../landing/main-banner/ScheduleButton';
const Power = () => {
    const { pathname } = useLocation();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [pathname]);

    const cardVariants = {
        hidden: { opacity: 0, y: 40 },
        visible: {
            opacity: 1,
            y: 0,
            transition: { duration: 0.6, ease: "easeOut" },
        },
    };

    const options = {
        margin: window.innerWidth > 600 ? 20 : 10,
        loop: true,
        autoplay: window.innerWidth > 600 ? true : false,
        autoplayTimeout: window.innerWidth > 600 ? 2000 : null,
        autoplayHoverPause: window.innerWidth > 600 ? true : false,
        smartSpeed: 600,
        autoplaySpeed: 600,
        nav: true,
        dots: false,
        navText: [
            "<img src='/assets/left.svg'/>",
            "<img src='/assets/right.svg'/>",
        ],
        responsive: {
            0: { items: 1 },
            300: { items: 1.1 },
            400: { items: 1.1 },
            600: { items: 1.1 },
            1000: { items: 2.5 },
            1300: { items: 3.5 },
        },
    };

    const testimonials = [
        {
            name: "Request & Approval Workflows",
            quote:
                "Leave requests, purchase orders, budget approvals, CapEx/OpEx flows",
            img: "/assets/doone.svg",
        },
        {
            name: "Employee Lifecycle Automation",
            quote:
                "Onboarding/offboarding, role-based access provisioning, welcome  notifications",
            img: "/assets/dotwo.svg",
        },
        {
            name: "Sales & Service Pipelines",
            quote:
                "Client onboarding, quote generation, SLA reminders, feedback collection",
            img: "/assets/dothree.svg",
        },
        {
            name: "Tailored Security Posture Improvement Recommendations",
            quote:
                "Receive customized recommendations designed to enhance your overall security posture, aligning with your specific business needs.",
            img: "/assets/dofour.svg",
        },
    ];

    const cardsData = [
        {
            title: "Experienced leadership",
            desc: "Stay ahead of threats with ongoing assessments and monitoring, ensuring your defenses remain robust against new vulnerabilities.",
            img: "/assets/paone.svg",
        },
        {
            title: "Fast delivery (<7 days)",
            desc: "Leverage our team's expertise to gain deep insights into your security strengths and weaknesses, empowering you to make informed decisions.",
            img: "/assets/patwo.svg",
        },
        {
            title: "Transparent pricing",
            desc: "Our proactive approach ensures that potential security issues are identified and addressed before they can impact your operations.",
            img: "/assets/pathree.svg",
        },
        {
            title: "Over 70 live flows",
            desc: "Enjoy the peace of mind that comes from knowing your organization is continuously protected by leading security experts.",
            img: "/assets/pafour.svg",
        },
        {
            title: "Zero outsourcing 100% attention",
            desc: "Our subscription model offers a cost-effective solution to obtaining top-tier security assessments, saving you the expense of in-house resources or one-off consultations.",
            img: "/assets/pafive.svg",
        },
        {
            title: "Lorem Ipsum",
            desc: "Our subscription model offers a cost-effective solution to obtaining top-tier security assessments, saving you the expense of in-house resources or one-off consultations.",
            img: "/assets/pafive.svg",
        },
    ];


    return (
        <>
            <section className="main-banner security_main">
                <Headernew />
                <video
                    className="main-banner-video"
                    muted
                    playsInline
                    autoPlay
                    loop
                    width="100%"
                    id="myVideo"
                >
                    <source src="/assets/bannervideo.mp4" type="video/mp4" />
                </video>

                <div className="custom-container1">
                    <div className="top_banner">
                        <motion.h3
                            initial={{ x: -100, opacity: 0 }}
                            whileInView={{ x: 0, opacity: 1 }}
                            viewport={{ once: false }} // 👈 animation runs every time on scroll
                            transition={{ duration: 1 }}
                        >
                            Business Process Automation
                        </motion.h3>


                    </div>
                    <motion.h4
                        initial={{ x: -100, opacity: 0 }}
                        whileInView={{ x: 0, opacity: 1 }}
                        viewport={{ once: false }} // 👈 animation runs every time on scroll
                        transition={{ duration: 1 }}
                    >
                        <div className='elevate_mains lastauses'>
                            <h4>Power Automate: Business Process Automation, Simplified</h4>
                            <p>Unlock the full potential of Microsoft Power Automate to streamline
                                your business operations, eliminate repetitive tasks, boost visibility,
                                and scale processes without writing a single line of code.
                            </p>


                        </div>
                    </motion.h4>


                </div>
            </section>
            <div className='marque_div'>
                <h3>Trusted By Clients Across Industries</h3>
                <div className="trendinganimations">
                    <div className="trendinganimationsright">
                        <div className="marquee">
                            <div className="marquee__group">
                                <div>
                                    <img className='imgunder' src="\assets\1.png" />
                                </div>
                                <div>
                                    <img className='imgunder' src="\assets\2.png" />
                                </div>
                                <div>
                                    <img className='imgunder' src="\assets\3.png" />
                                </div>
                                <div>
                                    <img className='imgunder' src="\assets\4.png" />
                                </div>
                                <div>
                                    <img className='imgunder' src="\assets\5.png" />
                                </div>
                                <div>
                                    <img className='imgunder' src="\assets\6.png" />
                                </div>
                                <div>
                                    <img className='imgunder' src="\assets\7.png" />
                                </div>
                                <div>
                                    <img className='imgunder' src="\assets\8.png" />
                                </div>
                                <div>
                                    <img className='imgunder' src="\assets\9.png" />
                                </div>
                                <div>
                                    <img className='imgunder' src="\assets\10.png" />
                                </div>
                                <div>
                                    <img className='imgunder' src="\assets\1.png" />
                                </div>
                                <div>
                                    <img className='imgunder' src="\assets\2.png" />
                                </div>

                                <div>
                                    <img className='imgunder' src="\assets\11.png" />
                                </div>
                                <div>
                                    <img className='imgunder' src="\assets\12.png" />
                                </div>






                            </div>
                            <div aria-hidden="true" className="marquee__group">
                                <div>
                                    <img className='imgunder' src="\assets\1.png" />
                                </div>
                                <div>
                                    <img className='imgunder' src="\assets\2.png" />
                                </div>
                                <div>
                                    <img className='imgunder' src="\assets\3.png" />
                                </div>
                                <div>
                                    <img className='imgunder' src="\assets\4.png" />
                                </div>
                                <div>
                                    <img className='imgunder' src="\assets\5.png" />
                                </div>
                                <div>
                                    <img className='imgunder' src="\assets\6.png" />
                                </div>
                                <div>
                                    <img className='imgunder' src="\assets\7.png" />
                                </div>
                                <div>
                                    <img className='imgunder' src="\assets\8.png" />
                                </div>
                                <div>
                                    <img className='imgunder' src="\assets\9.png" />
                                </div>
                                <div>
                                    <img className='imgunder' src="\assets\10.png" />
                                </div>
                                <div>
                                    <img className='imgunder' src="\assets\1.png" />
                                </div>
                                <div>
                                    <img className='imgunder' src="\assets\2.png" />
                                </div>

                                <div>
                                    <img className='imgunder' src="\assets\11.png" />
                                </div>
                                <div>
                                    <img className='imgunder' src="\assets\12.png" />
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className='nnew_cardfss'>
                <div className='custom-container1'>

                    <div className='challenge'>
                        <h5> Common Challenges We Solve</h5>
                        <div className='eight_cards11'>
                            <div className='cardnnnne'>
                                <img src='\assets\reeee.svg' />
                                <h6>Downtime & Manual
                                    Chaos</h6>
                                <p>Frustrated by constant IT issues, compliance alerts, and broken workflows?</p>
                            </div>
                            <div className='cardnnnne'>
                                <img src='\assets\reeee.svg' />
                                <h6>Bottlenecks & Approval Delays</h6>
                                <p>Wasting time managing repetitive admin tasks, manual approvals, and ticket queues?</p>
                            </div>
                            <div className='cardnnnne'>
                                <img src='\assets\reeee.svg' />
                                <h6>Disconnected Tools</h6>
                                <p>Struggling to unify Microsoft Teams, Forms, SharePoint, Outlook, and other tools?</p>
                            </div>


                        </div>
                        <h3>What if you could automate, secure, and unify it all without the overhead?</h3>
                    </div>

                </div>

            </div>
            <section className="slider_Div lassst_div">
                <h5>What We Automate</h5>
                <div className="cardshead">
                    <OwlCarousel className="owl-theme" {...options}>
                        {testimonials.map((t, i) => (
                            <motion.div
                                key={i}
                                className="cards"
                                variants={cardVariants}
                                initial="visible"
                                whileInView="visible"
                                viewport={{ once: false, amount: 0.4 }} // replay on every scroll‑in
                            >
                                <img className="imgggg" src={t.img} alt={t.name} />                <h2>{t.name}</h2>
                                <h3>{t.title}</h3>
                                <p>“{t.quote}”</p>
                            </motion.div>
                        ))}
                    </OwlCarousel>
                </div>
            </section>

            <section className='secure_main1'>
                <img src='/assets/elipses.png' className='elipses' alt='background design' />
                <div className='custom-container1'>
                    <div className='inner_secure'>
                        <h3>Why Choose TechSecure360?
                        </h3>
                        <div className='parent_four_cards'>
                            {cardsData.map((card, index) => (
                                <motion.div
                                    className='onne_card'
                                    key={index}
                                    custom={index}
                                    variants={cardVariants}
                                    initial='hidden'
                                    whileInView='visible'
                                    viewport={{ once: false, amount: 0.3 }} // triggers on scroll in & out
                                >
                                    <div>
                                        <h4>{card.title}</h4>
                                        {/* <p>{card.desc}</p> */}
                                    </div>
                                    <img src={card.img} alt={card.title} />
                                </motion.div>
                            ))}
                        </div>

                    </div>
                </div>
                {/* <p className='textdiv'>At TechSecure360, we are committed to helping organizations meet regulatory compliance requirements, strengthen their security measures, and effectively respond to security incidents. Contact us today to ensure your organization's security and regulatory needs are met with excellence.</p> */}
            </section>

            <Industries />


            {/* <div className='sub_mains'>
                <div className='custom-container1'>
                    <h3>Security Assessment Subscriptions</h3>

                    <div className='two_cardsmains'>
                        <div className='leftsidecards'>
                            <img src='\assets\shadee.png' className='shadeneww' />
                            <h4>Compliance Starter</h4>
                            <h5>$799/Month</h5>
                            <h6><svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
                                <path d="M10.0001 18.8334C14.6025 18.8334 18.3334 15.1025 18.3334 10.5001C18.3334 5.89771 14.6025 2.16675 10.0001 2.16675C5.39771 2.16675 1.66675 5.89771 1.66675 10.5001C1.66675 15.1025 5.39771 18.8334 10.0001 18.8334Z" fill="#1126E1" fill-opacity="0.15" />
                                <path d="M6.66675 11.0555L8.88897 13.2777L13.3334 8.83325" stroke="#1126E1" stroke-linecap="round" stroke-linejoin="round" />
                            </svg> Basic Compliance Assessment & Gap Analysis
                            </h6>
                            <h6><svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
                                <path d="M10.0001 18.8334C14.6025 18.8334 18.3334 15.1025 18.3334 10.5001C18.3334 5.89771 14.6025 2.16675 10.0001 2.16675C5.39771 2.16675 1.66675 5.89771 1.66675 10.5001C1.66675 15.1025 5.39771 18.8334 10.0001 18.8334Z" fill="#1126E1" fill-opacity="0.15" />
                                <path d="M6.66675 11.0555L8.88897 13.2777L13.3334 8.83325" stroke="#1126E1" stroke-linecap="round" stroke-linejoin="round" />
                            </svg> Standard Policy Development & Implementation Support

                            </h6>
                            <h6><svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
                                <path d="M10.0001 18.8334C14.6025 18.8334 18.3334 15.1025 18.3334 10.5001C18.3334 5.89771 14.6025 2.16675 10.0001 2.16675C5.39771 2.16675 1.66675 5.89771 1.66675 10.5001C1.66675 15.1025 5.39771 18.8334 10.0001 18.8334Z" fill="#1126E1" fill-opacity="0.15" />
                                <path d="M6.66675 11.0555L8.88897 13.2777L13.3334 8.83325" stroke="#1126E1" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>Annual Security Audit Against Industry Standards
                            </h6>
                            <h6><svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
                                <path d="M10.0001 18.8334C14.6025 18.8334 18.3334 15.1025 18.3334 10.5001C18.3334 5.89771 14.6025 2.16675 10.0001 2.16675C5.39771 2.16675 1.66675 5.89771 1.66675 10.5001C1.66675 15.1025 5.39771 18.8334 10.0001 18.8334Z" fill="#1126E1" fill-opacity="0.15" />
                                <path d="M6.66675 11.0555L8.88897 13.2777L13.3334 8.83325" stroke="#1126E1" stroke-linecap="round" stroke-linejoin="round" />
                            </svg> Customized Security Awareness Training (Annually)
                            </h6>
                            <h6><svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
                                <path d="M10.0001 18.8334C14.6025 18.8334 18.3334 15.1025 18.3334 10.5001C18.3334 5.89771 14.6025 2.16675 10.0001 2.16675C5.39771 2.16675 1.66675 5.89771 1.66675 10.5001C1.66675 15.1025 5.39771 18.8334 10.0001 18.8334Z" fill="#1126E1" fill-opacity="0.15" />
                                <path d="M6.66675 11.0555L8.88897 13.2777L13.3334 8.83325" stroke="#1126E1" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>Basic Incident Response Planning
                            </h6>
                            <h6><svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
                                <path d="M10.0001 18.8334C14.6025 18.8334 18.3334 15.1025 18.3334 10.5001C18.3334 5.89771 14.6025 2.16675 10.0001 2.16675C5.39771 2.16675 1.66675 5.89771 1.66675 10.5001C1.66675 15.1025 5.39771 18.8334 10.0001 18.8334Z" fill="#1126E1" fill-opacity="0.15" />
                                <path d="M6.66675 11.0555L8.88897 13.2777L13.3334 8.83325" stroke="#1126E1" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>Quarterly Compliance Monitoring & Updates
                            </h6>
                            <h6><svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
                                <path d="M10.0001 18.8334C14.6025 18.8334 18.3334 15.1025 18.3334 10.5001C18.3334 5.89771 14.6025 2.16675 10.0001 2.16675C5.39771 2.16675 1.66675 5.89771 1.66675 10.5001C1.66675 15.1025 5.39771 18.8334 10.0001 18.8334Z" fill="#1126E1" fill-opacity="0.15" />
                                <path d="M6.66675 11.0555L8.88897 13.2777L13.3334 8.83325" stroke="#1126E1" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>Email Support for Compliance Queries
                            </h6>
                            <button className='bluebutton'>Contact Us</button>

                        </div>

                        <div className='rightsidecards'>
                            <h4>Pro Package</h4>
                            <h5>$1399/Month</h5>
                            <h6><svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
                                <path d="M10.0001 18.8334C14.6025 18.8334 18.3334 15.1025 18.3334 10.5001C18.3334 5.89771 14.6025 2.16675 10.0001 2.16675C5.39771 2.16675 1.66675 5.89771 1.66675 10.5001C1.66675 15.1025 5.39771 18.8334 10.0001 18.8334Z" fill="#1126E1" fill-opacity="0.15" />
                                <path d="M6.66675 11.0555L8.88897 13.2777L13.3334 8.83325" stroke="#1126E1" stroke-linecap="round" stroke-linejoin="round" />
                            </svg> Comprehensive Compliance Assessment & Gap Analysis


                            </h6>
                            <h6><svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
                                <path d="M10.0001 18.8334C14.6025 18.8334 18.3334 15.1025 18.3334 10.5001C18.3334 5.89771 14.6025 2.16675 10.0001 2.16675C5.39771 2.16675 1.66675 5.89771 1.66675 10.5001C1.66675 15.1025 5.39771 18.8334 10.0001 18.8334Z" fill="#1126E1" fill-opacity="0.15" />
                                <path d="M6.66675 11.0555L8.88897 13.2777L13.3334 8.83325" stroke="#1126E1" stroke-linecap="round" stroke-linejoin="round" />
                            </svg> Advanced Policy Development & Implementation

                            </h6>
                            <h6><svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
                                <path d="M10.0001 18.8334C14.6025 18.8334 18.3334 15.1025 18.3334 10.5001C18.3334 5.89771 14.6025 2.16675 10.0001 2.16675C5.39771 2.16675 1.66675 5.89771 1.66675 10.5001C1.66675 15.1025 5.39771 18.8334 10.0001 18.8334Z" fill="#1126E1" fill-opacity="0.15" />
                                <path d="M6.66675 11.0555L8.88897 13.2777L13.3334 8.83325" stroke="#1126E1" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>Detailed Security Audits Against Industry Standards (Semi-annually)
                            </h6>
                            <h6><svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
                                <path d="M10.0001 18.8334C14.6025 18.8334 18.3334 15.1025 18.3334 10.5001C18.3334 5.89771 14.6025 2.16675 10.0001 2.16675C5.39771 2.16675 1.66675 5.89771 1.66675 10.5001C1.66675 15.1025 5.39771 18.8334 10.0001 18.8334Z" fill="#1126E1" fill-opacity="0.15" />
                                <path d="M6.66675 11.0555L8.88897 13.2777L13.3334 8.83325" stroke="#1126E1" stroke-linecap="round" stroke-linejoin="round" />
                            </svg> Customized Security Awareness Training (Semi-annually)
                            </h6>
                            <h6><svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
                                <path d="M10.0001 18.8334C14.6025 18.8334 18.3334 15.1025 18.3334 10.5001C18.3334 5.89771 14.6025 2.16675 10.0001 2.16675C5.39771 2.16675 1.66675 5.89771 1.66675 10.5001C1.66675 15.1025 5.39771 18.8334 10.0001 18.8334Z" fill="#1126E1" fill-opacity="0.15" />
                                <path d="M6.66675 11.0555L8.88897 13.2777L13.3334 8.83325" stroke="#1126E1" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>Strategic Incident Response Planning

                            </h6>
                            <h6><svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
                                <path d="M10.0001 18.8334C14.6025 18.8334 18.3334 15.1025 18.3334 10.5001C18.3334 5.89771 14.6025 2.16675 10.0001 2.16675C5.39771 2.16675 1.66675 5.89771 1.66675 10.5001C1.66675 15.1025 5.39771 18.8334 10.0001 18.8334Z" fill="#1126E1" fill-opacity="0.15" />
                                <path d="M6.66675 11.0555L8.88897 13.2777L13.3334 8.83325" stroke="#1126E1" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>Continuous Compliance Monitoring & Updates
                            </h6>
                            <h6><svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
                                <path d="M10.0001 18.8334C14.6025 18.8334 18.3334 15.1025 18.3334 10.5001C18.3334 5.89771 14.6025 2.16675 10.0001 2.16675C5.39771 2.16675 1.66675 5.89771 1.66675 10.5001C1.66675 15.1025 5.39771 18.8334 10.0001 18.8334Z" fill="#1126E1" fill-opacity="0.15" />
                                <path d="M6.66675 11.0555L8.88897 13.2777L13.3334 8.83325" stroke="#1126E1" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>Dedicated Support for Compliance Queries (Direct Access)
                            </h6>
                            <button className='whitebutton'>Contact Us</button>
                        </div>
                    </div>
                </div>

            </div> */}
            <section className='work_main'>
                {/* Background Shade Image */}
                <motion.img
                    src='/assets/shade.png'
                    className='imggshade'
                    initial={{ opacity: 0, scale: 0.95 }}
                    whileInView={{ opacity: 1, scale: 1 }}
                    transition={{ duration: 1 }}
                    viewport={{ once: false }}
                    alt='background shade'
                />

                {/* Background Video */}
                <motion.video
                    className='main-banner-video'
                    muted
                    playsInline
                    autoPlay
                    loop
                    width="100%"
                    id="myVideo"
                    initial={{ opacity: 0 }}
                    whileInView={{ opacity: 1 }}
                    transition={{ duration: 1.2 }}
                    viewport={{ once: false }}
                >
                    <source src="/assets/bottomvideo.mp4" type="video/mp4" />
                </motion.video>

                <div className='custom-container1'>
                    <motion.div
                        className='inner_work'
                        initial={{ opacity: 0, y: 50 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.8 }}
                        viewport={{ once: false }}
                    >
                        <h2>Ready to Modernize Your Workflows?</h2>

                        <motion.p
                            initial={{ opacity: 0, y: 20 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            transition={{ delay: 0.2, duration: 0.6 }}
                            viewport={{ once: false }}
                        >
                            Let’s talk about how we can secure and streamline your operations.
                        </motion.p>

                        <motion.div
                            className='buttons_div'
                            initial={{ opacity: 0, y: 20 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            transition={{ delay: 0.4, duration: 0.6 }}
                            viewport={{ once: false }}
                        >
                            <ScheduleButton />
                        </motion.div>
                    </motion.div>
                </div>
            </section>

        </>
    )
}

export default Power





